import React from "react";
import './healthCard.css'
const HealthCard = ({ cardInfo }) => {
  return (
    <div className="col-md-6  col-lg-4">
      <div className="card  health-card text-white">
        <img src={cardInfo?.img?.url} className="card-img" alt="..."></img>
      </div>
    </div>
  );
};

export default HealthCard;
